import type { Main4PageData } from '@/types/main4';

export const mockMain4PageData: Main4PageData = {
  heroQuotes: [
    {
      id: 1,
      categoryKey: 'yangbok',
      categoryLabel: '예복 후기',
      text: '원단 차이를 하나씩 설명해줘서 선택이 쉬웠어요.',
    },
    {
      id: 2,
      categoryKey: 'yemul',
      categoryLabel: '예물 후기',
      text: '디자인을 여러 개 비교할 수 있어서 좋았어요.',
    },
  ],

  heroFlowSteps: [
    {
      step: 1,
      label: '준비 항목 선택',
      description: '예복·예물·한복 중 준비 중인 항목을 선택',
      icon: 'ri-checkbox-circle-line',
    },
    {
      step: 2,
      label: '기준 정리',
      description: '분위기, 구성, 지역 등 중요한 기준을 정리',
      icon: 'ri-list-check-2',
    },
    {
      step: 3,
      label: '업체 비교',
      description: '기준에 맞는 인증업체를 확인',
      icon: 'ri-building-2-line',
    },
    {
      step: 4,
      label: '후기와 사진 확인',
      description: '실제 후기 요약, 후기 사진, 공식 룩북으로 검토',
      icon: 'ri-image-line',
    },
  ],

  problemCards: [
    {
      icon: 'ri-emotion-normal-line',
      title: '업체가 다 비슷해 보일 때',
      description: '사진과 소개글만 보면 차이를 판단하기 어렵습니다. 어떤 점을 중요하게 봐야 할지 몰라도 괜찮아요.',
    },
    {
      icon: 'ri-chat-history-line',
      title: '후기는 많은데 기준이 없을 때',
      description: '후기를 많이 읽어도 어떤 점을 중요하게 봐야 할지 모르면 선택이 더 어려워집니다.',
    },
    {
      icon: 'ri-scales-3-line',
      title: '가격보다 중요한 기준이 있을 때',
      description: '예복, 예물, 한복은 가격만으로 고르기 어렵습니다. 상담, 구성, 분위기, 사진, 지역까지 함께 봐야 합니다.',
    },
  ],

  preferenceGuideSteps: [
    {
      step: 1,
      title: '준비 항목 선택',
      description: '예복, 예물, 한복 중 보고 싶은 항목을 선택합니다.',
      icon: 'ri-checkbox-circle-line',
    },
    {
      step: 2,
      title: '분위기와 상황 선택',
      description: '원하는 스타일, 필요한 구성, 방문 지역 등을 선택합니다.',
      icon: 'ri-palette-line',
    },
    {
      step: 3,
      title: '선택 기준 정리',
      description: '내가 중요하게 봐야 할 기준이 리포트로 정리됩니다.',
      icon: 'ri-file-list-3-line',
    },
    {
      step: 4,
      title: '인증업체 연결',
      description: '기준에 맞는 인증업체와 실제 후기를 함께 확인합니다.',
      icon: 'ri-link-m',
    },
  ],

  reviewQuotes: [
    {
      id: 1,
      categoryKey: 'yangbok',
      categoryLabel: '예복 후기',
      text: '원단 차이를 하나씩 설명해줘서 선택이 쉬웠어요.',
    },
    {
      id: 2,
      categoryKey: 'yangbok',
      categoryLabel: '예복 후기',
      text: '촬영복 구성이 생각보다 다양해서 비교하기 좋았어요.',
    },
    {
      id: 3,
      categoryKey: 'yemul',
      categoryLabel: '예물 후기',
      text: '다이아 등급을 예산에 맞춰 설명해줘서 이해하기 쉬웠어요.',
    },
    {
      id: 4,
      categoryKey: 'yemul',
      categoryLabel: '예물 후기',
      text: '커플링 디자인을 여러 개 비교할 수 있어서 좋았어요.',
    },
    {
      id: 5,
      categoryKey: 'hanbok',
      categoryLabel: '한복 후기',
      text: '혼주 한복 색감 상담이 꼼꼼해서 선택이 편했어요.',
    },
    {
      id: 6,
      categoryKey: 'hanbok',
      categoryLabel: '한복 후기',
      text: '촬영 한복과 본식 한복을 함께 비교하기 좋았어요.',
    },
  ],

  reviewPhotos: [
    { id: 1, categoryKey: 'yangbok', categoryLabel: '예복', caption: '수트 피팅 후기 사진', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20wedding%20groom%20suit%20fitting%20moment%20elegant%20tailored%20jacket%20warm%20cream%20studio%20background%20editorial%20photography%20soft%20natural%20lighting%20premium%20menswear%20aesthetic%20refined%20atmosphere&width=400&height=400&seq=main4-review-1&orientation=squarish' },
    { id: 2, categoryKey: 'yemul', categoryLabel: '예물', caption: '커플링 비교 후기 사진', imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20couple%20wedding%20rings%20displayed%20on%20cream%20silk%20fabric%20warm%20ambient%20lighting%20luxury%20detail%20editorial%20photography%20Korean%20jewelry%20aesthetic%20refined%20minimal%20composition&width=400&height=400&seq=main4-review-2&orientation=squarish' },
    { id: 3, categoryKey: 'hanbok', categoryLabel: '한복', caption: '한복 피팅 후기 사진', imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20Korean%20traditional%20hanbok%20fitting%20for%20wedding%20bride%20soft%20pastel%20silk%20colors%20warm%20cream%20background%20editorial%20photography%20elegant%20flowing%20fabric%20details%20refined%20atmosphere&width=400&height=400&seq=main4-review-3&orientation=squarish' },
    { id: 4, categoryKey: 'yangbok', categoryLabel: '상담', caption: '원단 상담 후기 사진', imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20fabric%20consultation%20at%20Korean%20tailor%20shop%20various%20wool%20and%20silk%20swatches%20arranged%20on%20wooden%20table%20warm%20cream%20lighting%20editorial%20photography%20sophisticated%20textile%20display&width=400&height=400&seq=main4-review-4&orientation=squarish' },
    { id: 5, categoryKey: 'yemul', categoryLabel: '상담', caption: '예물 상담 후기 사진', imageUrl: 'https://readdy.ai/api/search-image?query=Intimate%20Korean%20jewelry%20consultation%20moment%20couple%20discussing%20ring%20options%20elegant%20boutique%20interior%20warm%20ambient%20lighting%20cream%20tones%20editorial%20photography%20refined%20atmosphere&width=400&height=400&seq=main4-review-5&orientation=squarish' },
    { id: 6, categoryKey: 'hanbok', categoryLabel: '혼주', caption: '혼주 한복 후기 사진', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20traditional%20mother%20of%20bride%20hanbok%20in%20elegant%20deep%20jewel%20tones%20silk%20fabric%20warm%20cream%20background%20editorial%20photography%20sophisticated%20colors%20refined%20details%20graceful%20atmosphere&width=400&height=400&seq=main4-review-6&orientation=squarish' },
    { id: 7, categoryKey: 'yangbok', categoryLabel: '촬영', caption: '촬영 예복 후기 사진', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20wedding%20groom%20suit%20styling%20moment%20warm%20natural%20daylight%20cream%20interior%20editorial%20photography%20candid%20refined%20atmosphere%20premium%20menswear%20detail%20elegant%20composition&width=400&height=400&seq=main4-review-7&orientation=squarish' },
    { id: 8, categoryKey: 'yemul', categoryLabel: '반지', caption: '반지 착용 후기 사진', imageUrl: 'https://readdy.ai/api/search-image?query=Close%20up%20elegant%20hand%20wearing%20wedding%20ring%20soft%20warm%20lighting%20cream%20background%20editorial%20photography%20Korean%20jewelry%20aesthetic%20refined%20minimal%20detail%20sophisticated%20sparkle&width=400&height=400&seq=main4-review-8&orientation=squarish' },
    { id: 9, categoryKey: 'hanbok', categoryLabel: '커플', caption: '커플 한복 후기 사진', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20traditional%20couple%20hanbok%20wedding%20photography%20elegant%20bride%20and%20groom%20in%20matching%20silk%20hanbok%20warm%20cream%20background%20editorial%20photography%20refined%20composition%20sophisticated%20colors&width=400&height=400&seq=main4-review-9&orientation=squarish' },
    { id: 10, categoryKey: 'yangbok', categoryLabel: '피팅', caption: '예복 피팅 후기 사진', imageUrl: 'https://readdy.ai/api/search-image?query=Close%20up%20Korean%20groom%20wedding%20suit%20fitting%20detail%20premium%20fabric%20texture%20elegant%20lapel%20warm%20cream%20background%20editorial%20photography%20refined%20menswear%20aesthetic%20sophisticated%20tailoring&width=400&height=400&seq=main4-review-10&orientation=squarish' },
    { id: 11, categoryKey: 'yemul', categoryLabel: '케이스', caption: '예물 케이스 후기 사진', imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20jewelry%20presentation%20case%20interior%20elegant%20ring%20and%20diamond%20display%20cream%20velvet%20lining%20warm%20soft%20lighting%20editorial%20photography%20Korean%20aesthetic%20refined%20organization&width=400&height=400&seq=main4-review-11&orientation=squarish' },
    { id: 12, categoryKey: 'hanbok', categoryLabel: '촬영', caption: '촬영 한복 후기 사진', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20wedding%20photography%20preparation%20with%20traditional%20hanbok%20elegant%20silk%20fabric%20flowing%20warm%20natural%20lighting%20cream%20background%20editorial%20photography%20refined%20composition%20sophisticated%20detail&width=400&height=400&seq=main4-review-12&orientation=squarish' },
  ],

  categoryCards: [
    {
      key: 'yangbok',
      title: '예복',
      description: '맞춤·대여·촬영복까지 비교',
      guideText: '핏, 원단, 촬영복 구성, 본식 예복 기준을 정리해요.',
      preferencePath: '/guide/yangbok',
      listPath: '/shops/suit',
      vibeLabels: ['수트', '원단'],
      vibeImageUrls: [
        'https://readdy.ai/api/search-image?query=Premium%20Korean%20wedding%20suit%20displayed%20on%20mannequin%20warm%20cream%20background%20tailored%20fit%20editorial%20photography%20refined%20menswear%20aesthetic%20sophisticated%20composition%20soft%20natural%20lighting%20elegant%20fabric%20detail&width=400&height=250&seq=main4-vibe-yangbok-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Selection%20of%20premium%20wool%20and%20silk%20suiting%20fabrics%20arranged%20elegantly%20on%20wooden%20display%20table%20warm%20cream%20lighting%20editorial%20photography%20Korean%20tailor%20aesthetic%20sophisticated%20texture&width=400&height=250&seq=main4-vibe-yangbok-2&orientation=landscape',
      ],
    },
    {
      key: 'yemul',
      title: '예물',
      description: '다이아·커플링·예물 구성을 비교',
      guideText: '예산, 디자인, 브랜드, 구성 기준을 정리해요.',
      preferencePath: '/guide/yemul',
      listPath: '/shops/jewelry',
      vibeLabels: ['반지', '다이아'],
      vibeImageUrls: [
        'https://readdy.ai/api/search-image?query=Elegant%20couple%20wedding%20rings%20on%20cream%20silk%20surface%20warm%20golden%20ambient%20lighting%20luxury%20detail%20editorial%20photography%20Korean%20jewelry%20aesthetic%20refined%20minimal%20composition%20sophisticated%20sparkle&width=400&height=250&seq=main4-vibe-yemul-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Premium%20diamond%20ring%20displayed%20on%20cream%20velvet%20cushion%20brilliant%20cut%20sparkle%20warm%20soft%20lighting%20editorial%20photography%20Korean%20jewelry%20aesthetic%20sophisticated%20detail%20refined%20composition&width=400&height=250&seq=main4-vibe-yemul-2&orientation=landscape',
      ],
    },
    {
      key: 'hanbok',
      title: '한복',
      description: '신랑신부·혼주 한복까지 비교',
      guideText: '촬영, 본식, 혼주 한복 기준을 정리해요.',
      preferencePath: '/guide/hanbok',
      listPath: '/shops/hanbok',
      vibeLabels: ['원단', '색감'],
      vibeImageUrls: [
        'https://readdy.ai/api/search-image?query=Beautiful%20Korean%20traditional%20silk%20fabrics%20in%20soft%20pastel%20and%20jewel%20tones%20displayed%20elegantly%20warm%20cream%20lighting%20editorial%20photography%20hanbok%20textile%20aesthetic%20refined%20composition%20sophisticated%20color%20palette&width=400&height=250&seq=main4-vibe-hanbok-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Korean%20traditional%20hanbok%20color%20palette%20display%20with%20various%20silk%20swatches%20harmonious%20tones%20warm%20cream%20background%20editorial%20photography%20refined%20aesthetic%20sophisticated%20color%20coordination&width=400&height=250&seq=main4-vibe-hanbok-2&orientation=landscape',
      ],
    },
  ],

  partnerDetailData: {
    displayName: '헤리츠테일러',
    areaName: '청담',
    reviewSummaryText: '핏 조정과 상담 설명에 대한 만족도가 반복적으로 확인돼요.',
    reviewCount: 284,
    photoCount: 36,
    keywords: ['체형보정', '촬영복구성', '프리미엄원단'],
    detailPhotos: [
      { imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20wedding%20groom%20suit%20fitting%20moment%20elegant%20tailored%20jacket%20warm%20cream%20studio%20background%20editorial%20photography%20soft%20natural%20lighting%20premium%20menswear%20detail&width=300&height=200&seq=main4-partner-dp-1&orientation=landscape', label: '수트 피팅' },
      { imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20fabric%20consultation%20Korean%20tailor%20shop%20wool%20silk%20swatches%20warm%20cream%20lighting%20editorial%20photography%20sophisticated%20textile%20display%20refined%20atmosphere&width=300&height=200&seq=main4-partner-dp-2&orientation=landscape', label: '원단 상담' },
      { imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20wedding%20groom%20suit%20styling%20moment%20warm%20natural%20daylight%20cream%20interior%20editorial%20photography%20candid%20refined%20atmosphere%20elegant%20composition&width=300&height=200&seq=main4-partner-dp-3&orientation=landscape', label: '촬영 예복' },
    ],
    lookbookPhotos: [
      { imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20luxury%20menswear%20atelier%20premium%20suit%20display%20warm%20cream%20interior%20soft%20ambient%20lighting%20editorial%20photography%20high-end%20bespoke%20atmosphere&width=300&height=200&seq=main4-partner-lb-1&orientation=landscape', label: '공식 룩북' },
      { imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20Korean%20tailor%20shop%20interior%20premium%20suits%20wooden%20shelves%20warm%20cream%20lighting%20editorial%20photography%20sophisticated%20atmosphere%20refined%20composition&width=300&height=200&seq=main4-partner-lb-2&orientation=landscape', label: '매장 내부' },
    ],
  },

  detailCheckItems: [
    {
      icon: 'ri-message-3-line',
      title: '후기 요약',
      description: '반복적으로 언급된 장점과 확인할 점을 한눈에 볼 수 있어요.',
    },
    {
      icon: 'ri-image-line',
      title: '후기 사진',
      description: '실제 다이렉트 카페 후기에서 수집된 사진을 확인할 수 있어요.',
    },
    {
      icon: 'ri-gallery-line',
      title: '공식 룩북',
      description: '업체가 직접 보여주고 싶은 공식 사진을 따로 볼 수 있어요.',
    },
    {
      icon: 'ri-map-pin-line',
      title: '지역별 비교',
      description: '청담, 강남, 종로 등 방문 가능한 지역 기준으로 비교할 수 있어요.',
    },
    {
      icon: 'ri-information-line',
      title: '혜택·예약 안내',
      description: '상담 전에 확인할 혜택과 예약 정보를 미리 알 수 있어요.',
    },
  ],

  featuredShops: {
    yangbok: [
      {
        id: 1,
        categoryKey: 'yangbok',
        displayName: '헤리츠테일러',
        areaName: '청담',
        reviewSummaryText: '핏 조정과 상담 설명에 대한 만족도가 반복적으로 확인돼요.',
        reviewCount: 284,
        photoCount: 36,
        keywords: ['체형보정', '촬영복구성', '프리미엄원단'],
        shopSlug: 'heritztailor-cheongdam',
        imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20luxury%20Korean%20menswear%20tailor%20shop%20interior%20warm%20cream%20tones%20premium%20suit%20display%20wooden%20shelves%20soft%20ambient%20lighting%20editorial%20photography%20sophisticated%20atmosphere%20high-end%20bespoke&width=800&height=500&seq=main4-shop-yangbok-1&orientation=landscape',
      },
      {
        id: 2,
        categoryKey: 'yangbok',
        displayName: '빌리언즈테일러',
        areaName: '청담',
        reviewSummaryText: '원단 선택과 예복 구성 설명이 자세하다는 후기가 많아요.',
        reviewCount: 198,
        photoCount: 28,
        keywords: ['맞춤예복', '원단선택', '상담친절'],
        shopSlug: 'billions-tailor',
        imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20luxury%20Korean%20menswear%20atelier%20with%20premium%20wool%20fabric%20rolls%20displayed%20on%20wooden%20shelves%20warm%20ambient%20lighting%20cream%20walls%20editorial%20photography%20elegant%20interior%20design&width=800&height=500&seq=main4-shop-yangbok-2&orientation=landscape',
      },
      {
        id: 3,
        categoryKey: 'yangbok',
        displayName: '아틀레',
        areaName: '강남',
        reviewSummaryText: '촬영복 구성과 본식 예복을 함께 비교하기 좋다는 평가가 있어요.',
        reviewCount: 156,
        photoCount: 22,
        keywords: ['촬영복', '본식예복', '구성좋음'],
        shopSlug: 'atelier',
        imageUrl: 'https://readdy.ai/api/search-image?query=Contemporary%20Korean%20menswear%20atelier%20with%20clean%20minimal%20interior%20white%20walls%20warm%20beige%20accents%20premium%20suit%20display%20natural%20daylight%20editorial%20photography%20elegant%20calm%20atmosphere&width=800&height=500&seq=main4-shop-yangbok-3&orientation=landscape',
      },
    ],
    yemul: [
      {
        id: 4,
        categoryKey: 'yemul',
        displayName: '로제쥬얼리',
        areaName: '청담',
        reviewSummaryText: '다이아 등급과 예산 설명이 자세하다는 후기가 많아요.',
        reviewCount: 142,
        photoCount: 18,
        keywords: ['다이아', '커플링', '예산상담'],
        shopSlug: 'roze-jewelry',
        imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20luxury%20jewelry%20store%20interior%20in%20Cheongdam%20premium%20diamond%20display%20cases%20warm%20cream%20lighting%20sophisticated%20atmosphere%20editorial%20photography%20refined%20Korean%20jewelry%20boutique&width=800&height=500&seq=main4-shop-yemul-1&orientation=landscape',
      },
      {
        id: 5,
        categoryKey: 'yemul',
        displayName: '라움주얼리',
        areaName: '종로',
        reviewSummaryText: '커플링 디자인 선택지가 다양하다는 평가가 있어요.',
        reviewCount: 118,
        photoCount: 20,
        keywords: ['커플링', '디자인', '종로'],
        shopSlug: 'raum-jewelry',
        imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20jewelry%20shop%20interior%20in%20Jongno%20couple%20ring%20displays%20warm%20ambient%20lighting%20clean%20cream%20aesthetic%20editorial%20photography%20contemporary%20elegant%20design&width=800&height=500&seq=main4-shop-yemul-2&orientation=landscape',
      },
      {
        id: 6,
        categoryKey: 'yemul',
        displayName: '모브주얼리',
        areaName: '강남',
        reviewSummaryText: '상담이 차분하고 예물 구성을 비교하기 좋다는 후기가 있어요.',
        reviewCount: 94,
        photoCount: 15,
        keywords: ['예물구성', '상담친절', '디자인'],
        shopSlug: 'mauve-jewelry',
        imageUrl: 'https://readdy.ai/api/search-image?query=Intimate%20Korean%20fine%20jewelry%20boutique%20in%20Gangnam%20soft%20warm%20lighting%20elegant%20ring%20displays%20cream%20interior%20editorial%20photography%20premium%20craftsmanship%20refined%20atmosphere&width=800&height=500&seq=main4-shop-yemul-3&orientation=landscape',
      },
    ],
    hanbok: [
      {
        id: 7,
        categoryKey: 'hanbok',
        displayName: '채율한복',
        areaName: '강남',
        reviewSummaryText: '혼주 한복 색감과 상담 만족도가 반복적으로 언급돼요.',
        reviewCount: 132,
        photoCount: 24,
        keywords: ['혼주한복', '색감', '맞춤'],
        shopSlug: 'chaeyul-hanbok',
        imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20Korean%20hanbok%20boutique%20interior%20with%20traditional%20fabric%20rolls%20displayed%20warm%20cream%20lighting%20soft%20atmosphere%20editorial%20photography%20refined%20wedding%20hanbok%20shop%20premium%20aesthetic&width=800&height=500&seq=main4-shop-hanbok-1&orientation=landscape',
      },
      {
        id: 8,
        categoryKey: 'hanbok',
        displayName: '소담한복',
        areaName: '청담',
        reviewSummaryText: '촬영 한복과 본식 한복을 함께 비교하기 좋다는 평가가 있어요.',
        reviewCount: 102,
        photoCount: 21,
        keywords: ['촬영한복', '본식한복', '구성'],
        shopSlug: 'sodam-hanbok',
        imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20Korean%20hanbok%20atelier%20in%20Cheongdam%20with%20beautiful%20silk%20fabrics%20on%20display%20warm%20golden%20lighting%20cream%20interior%20editorial%20photography%20sophisticated%20traditional%20meets%20modern&width=800&height=500&seq=main4-shop-hanbok-2&orientation=landscape',
      },
      {
        id: 9,
        categoryKey: 'hanbok',
        displayName: '온유한복',
        areaName: '종로',
        reviewSummaryText: '대여 구성과 가격 안내가 명확하다는 후기가 있어요.',
        reviewCount: 88,
        photoCount: 16,
        keywords: ['대여한복', '종로', '구성안내'],
        shopSlug: 'onyu-hanbok',
        imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20Korean%20hanbok%20rental%20shop%20interior%20in%20Jongno%20traditional%20and%20modern%20hanbok%20display%20soft%20cream%20lighting%20cozy%20atmosphere%20editorial%20photography%20approachable%20elegance&width=800&height=500&seq=main4-shop-hanbok-3&orientation=landscape',
      },
    ],
  },
};